// Canonical public site origin (production domain) used for canonical URLs,
// Open Graph links and share content. Configured via env so it is not a
// hardcoded literal; falls back to the current origin when unset.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || (typeof window !== 'undefined' ? window.location.origin : '')).replace(/\/$/, '');
export const SITE_DOMAIN = SITE_URL.replace(/^https?:\/\//, '');
